import { ISDCardPacket } from '../interfaces/ISDCardPacket'

export function parseSDCardPacket(telemetryPackage: string): ISDCardPacket | null {
    // 124180 ms, lox  0.24 bar, fuel  0.24 bar, dpr   0.61 bar, lox mode 0, lox 65535 ticks, fuel mode 0, fuel 65535 ticks
    const regex =
        /(\d+) ms, lox\s+(-?[\d.]+) bar, fuel\s+(-?[\d.]+) bar, dpr\s+(-?[\d.]+) bar, lox mode (\d+), lox (\d+) ticks, fuel mode (\d+), fuel (\d+) ticks/

    const match = telemetryPackage.match(regex)
    if (!match) return null

    return {
        timestamp: parseInt(match[1]),
        lox: parseFloat(match[2]),
        fuel: parseFloat(match[3]),
        dpr: parseFloat(match[4]),
        loxMode: parseInt(match[5]),
        loxTicks: parseInt(match[6]),
        fuelMode: parseInt(match[7]),
        fuelTicks: parseInt(match[8]),
        message: telemetryPackage,
    }
}
